import CreateCampaignDialog from "./CreateCampaignDialog";

export default function AddPlaceDialog({
  open,
  onboarding,
  setOpen,
}: {
  open: boolean;
  onboarding?: boolean;
  setOpen: (open: boolean) => void;
}) {
  return (
    <CreateCampaignDialog open={open} setOpen={setOpen} place={true} onboarding={onboarding} />
  );
}
